<div
  *ngIf="(svc.canInstall$ | async) && !(svc.installed$ | async) && !dismissed"
  class="fixed left-4 bottom-[5rem] z-[1000]"
  aria-live="polite"
>
  <div
    class="flex items-center gap-3 rounded-xl px-4 py-3 shadow-xl bg-white/90 dark:bg-zinc-800/90 backdrop-blur ring-1 ring-black/5 dark:ring-white/10 max-w-[92vw]"
  >
    <div
      class="shrink-0 h-9 w-9 rounded-lg grid place-items-center bg-black/5 dark:bg-white/10"
    >
      <!-- simple "download" arrow -->
      <svg viewBox="0 0 24 24" class="h-5 w-5" aria-hidden="true">
        <path
          d="M12 3v10m0 0l4-4m-4 4l-4-4M5 21h14"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>

    <div class="min-w-0">
      <div class="text-sm font-semibold leading-5">Install {{ appShortName }}</div>
      <div class="text-xs opacity-70 leading-4">
        Faster access for mobile and tablet. Works offline.
      </div>
    </div>

    <div class="ml-2 flex items-center gap-2">
      <button
        type="button"
        (click)="install()"
        class="px-3 py-1.5 text-sm font-semibold rounded-lg bg-black text-white dark:bg-white dark:text-black hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-black/60 dark:focus-visible:ring-white/60"
      >
        Install
      </button>

      <button
        type="button"
        (click)="dismiss()"
        class="p-2 rounded-md hover:bg-black/5 dark:hover:bg-white/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-black/60 dark:focus-visible:ring-white/60"
        aria-label="Dismiss install prompt"
      >
        <span aria-hidden="true">×</span>
      </button>
    </div>
  </div>
</div>
